<template>
  <div id="contenedor-main-auditoria-informe-observaciones">
    <v-container fluid>
      <v-card flat class="mb-4 rounded-lg">
        <v-card-text class="px-0 py-1">
          <titulo-tool-bar
            titulo="Observaciones"
            nombreRuta="auditoriaInformes"
            regresar>
            <template v-slot:end>
              <span class="subtitle-2 text--secondary">
                Informe: {{ getAuditoriaInforme.nombre }}
              </span>
            </template>
            <template v-slot:opciones-derecha>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon>
                    <v-icon>
                      mdi-cog-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense nav>
                  <v-list-item
                  @click="mostrarCatalogoEtiquetas = !mostrarCatalogoEtiquetas">
                  <v-list-item-icon class="mr-2">
                    <v-icon>
                      mdi-label
                    </v-icon>
                  </v-list-item-icon>
                    <v-list-item-title>
                      Etiquetas
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
            </v-menu>
            </template>
          </titulo-tool-bar>
          <v-toolbar flat dense>
            <v-spacer></v-spacer>
            <v-tooltip
            v-if="getAuditoriaInforme.dataFile && getAuditoriaInforme.dataFile !==''
            ? true:false" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  color="red"
                  @click="verPdf(getAuditoriaInforme)">
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span>Ver PDF</span>
            </v-tooltip>
            <v-btn
              v-if="mixValidaScopesActions(1)"
              color="primary"
              rounded
              @click="mostrarAgregarInformeAuditoria = !mostrarAgregarInformeAuditoria">
              <v-icon left small>
                mdi-plus
              </v-icon>
              Nueva
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>
      <v-card flat>
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <listado
            v-if="!$apollo.loading"
            :solo-lectura="soloLectura"
            :listadoObservaciones="getAuditoriaInformeObservaciones"
            :informe="getAuditoriaInforme"
            >
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-if="!$apollo.loading && mostrarAgregarInformeAuditoria"
      v-model="mostrarAgregarInformeAuditoria"
      scrollable
      persistent
      width="750px">
      <Nueva
        :informe="getAuditoriaInforme"
        v-on:cerrar="mostrarAgregarInformeAuditoria = !mostrarAgregarInformeAuditoria">
      </Nueva>
    </v-dialog>
    <v-dialog
      v-if="!$apollo.loading && mostrarAgregarDetalleObservacion"
      v-model="mostrarAgregarDetalleObservacion"
      scrollable
      persistent
      width="750px">
      <NuevoDetalle
        :observacion="estaObservacion"
        :informe="getAuditoriaInforme"
        v-on:cerrar="mostrarAgregarDetalleObservacion = !mostrarAgregarDetalleObservacion">
      </NuevoDetalle>
    </v-dialog>
    <!-- Ventana Ver Pdf Informe -->
    <v-dialog
      v-if="!$apollo.loading && esteInforme && mostrarVerPdfAuditoriaInforme"
      v-model="mostrarVerPdfAuditoriaInforme"
      persistent
      scrollable
      width="750px">
      <v-card>
        <v-card-title>
          {{ esteInforme.numeroOficio }}
          / {{ esteInforme.nombre }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrarPdf()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <VistaPreviaPdf
            :ruta-archivo="esteInforme.dataFile">
          </VistaPreviaPdf>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="mostrarCatalogoEtiquetas"
      v-model="mostrarCatalogoEtiquetas"
      width="600">
      <v-card>
        <v-card-title class="secondary--text">
            Etiquetas de Auditorias
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrarCatalogoEtiquetas">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
        <v-card-text>
          <CatalogoEtiquetasAuditorias />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import AUDITORIA_INFORME from '@/graphql/querys/administracion/auditorias/auditoriaInforme.gql';
import AUDITORIA_INFORME_OBSERVACIONES from '@/graphql/querys/administracion/auditorias/auditoriaInformeObservaciones.gql';
import listado from '@/views/administracion/auditorias/auditoria/informes/observaciones/listado/Main.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import Nueva from '@/components/administracion/auditorias/observaciones/Nueva.vue';
import NuevoDetalle from '@/components/administracion/auditorias/observaciones/detalles/Nuevo.vue';
import eventBus from '@/helpers/eventBus';
import VistaPreviaPdf from '@/components/administracion/auditorias/informes/verPdf.vue';
import CatalogoEtiquetasAuditorias from './configuracion/catalogo-etiquetas/Main.vue';

export default {
  name: 'MainAuditoriaInformeObservaciones',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      mostrarAgregarInformeAuditoria: false,
      mostrarAgregarDetalleObservacion: false,
      mostrarVerPdfAuditoriaInforme: false,
      mostrarCatalogoEtiquetas: false,
      estaObservacion: null,
      esteInforme: null,
    };
  },
  components: {
    Nueva,
    NuevoDetalle,
    TituloToolBar,
    listado,
    VistaPreviaPdf,
    CatalogoEtiquetasAuditorias,
  },
  apollo: {
    auditoriaInformeObservaciones: {
      query: AUDITORIA_INFORME_OBSERVACIONES,
      variables() {
        return {
          idInforme: this.$route.params.idInforme,
        };
      },
    },
    auditoriaInforme: {
      query: AUDITORIA_INFORME,
      variables() {
        return {
          id: this.$route.params.idInforme,
        };
      },
    },
  },
  mounted() {
    eventBus.$on('agregar-detalle-observacion', (observacion) => {
      this.estaObservacion = observacion;
      this.mostrarAgregarDetalleObservacion = true;
    });
    eventBus.$on('refresh-listado-observaciones', this.refrescarListado);
  },
  computed: {
    getAuditoriaInformeObservaciones() {
      if (!this.auditoriaInformeObservaciones) return [];
      return this.auditoriaInformeObservaciones
        .slice()
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
        .map((observacion) => ({
          ...observacion,
        }));
    },
    getAuditoriaInforme() {
      if (!this.auditoriaInforme) return [];
      return this.auditoriaInforme;
    },

  },
  methods: {
    async refrescarListado() {
      await this.$apollo.queries.auditoriaInformeObservaciones.refetch({
        idInforme: this.$route.params.idInforme,
      });
    },
    cerrarCatalogoEtiquetas() {
      this.mostrarCatalogoEtiquetas = false;
    },
    verPdf(informe) {
      this.mostrarVerPdfAuditoriaInforme = true;
      this.esteInforme = informe;
    },
    cerrarPdf() {
      this.mostrarVerPdfAuditoriaInforme = !this.mostrarVerPdfAuditoriaInforme;
      this.esteInforme = null;
    },
  },

};
</script>
